import { pick } from "lodash";

import { ChartSettings } from "@/classes/BaseChart/index";
import { displaySettingsNames } from "@/settings/charts";
import { ChartDataRecord } from "@/types/charts";

class ChartWithData {
  declare settings: ChartSettings;

  private cleanData(data: Record<string, unknown>[]): Record<string, unknown>[] {
    return data.map((item: Record<string, unknown>) => pick(item, [...this.chartDataFields()]));
  }

  protected chartDataFields(): string[] {
    const existingSettings = Object.keys(this?.settings || {}).filter((key) => displaySettingsNames.includes(key));

    return existingSettings.map((settingName) => this.settings[settingName]);
  }

  protected prepareTopPlanModuleData(
    data: ChartDataRecord[],
    decompositionMetric: string,
    displayMetric: string,
    showItems: number
  ): ChartDataRecord[] {
    const groupedPreparedDataMap = data.reduce<Record<string, number>>((acc, item) => {
      const groupKey = item[decompositionMetric] as string;
      const currentValue = Number(item[displayMetric] ?? 0);

      acc[groupKey] = (acc[groupKey] || 0) + currentValue;

      return acc;
    }, {});

    const groupedPreparedData = Object.entries(groupedPreparedDataMap).map(([key, total]) => ({ key, total }));
    const sortedGroupedPreparedData = groupedPreparedData.sort((a, b) => b.total - a.total);
    const selectedGroupedPreparedData = sortedGroupedPreparedData.slice(0, showItems);
    const selectedDimensions = selectedGroupedPreparedData.map((item) => item.key);

    return data.filter((item) => selectedDimensions.includes((item[decompositionMetric] as string) ?? ""));
  }
}

export default ChartWithData;
